//文章
const taokeBox = () => import('@/components/taoke/taokeBox');
const taokeGoodsList = () => import('@/components/taoke/goods/taokeGoodsList');


export default {
    path: '/taokeBox',
    name: 'taokeBox',
    component: taokeBox,
    children: [
        { path: 'taokeGoodsList', component: taokeGoodsList, name: 'taokeGoodsList' },
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/taoke.js